import { useState } from "react";
import { toast } from "sonner";
import { X, Upload } from "lucide-react";
import { api, imgSrc, formatApiError } from "@/lib/api";

export const ImageUploader = ({ images, onChange }) => {
  const [busy, setBusy] = useState(false);
  const [url, setUrl] = useState("");

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    const added = [];
    for (const f of files) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/admin/uploads/photo", fd);
        added.push(data.url);
      } catch (err) {
        toast.error(`${f.name}: ${formatApiError(err)}`);
      }
    }
    onChange([...images, ...added]);
    setBusy(false);
    e.target.value = "";
  };

  const addUrl = () => {
    if (!url.trim()) return;
    onChange([...images, url.trim()]);
    setUrl("");
  };

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {images.map((src, i) => (
          <div key={src + i} className="relative aspect-square bg-[#F3F1ED] overflow-hidden" data-testid={`admin-image-${i}`}>
            <img src={imgSrc(src)} alt="" className="h-full w-full object-cover" />
            {i === 0 && <span className="absolute bottom-1 left-1 bg-[#121417] text-white text-[10px] px-1.5 font-plex">COVER</span>}
            <button type="button" onClick={() => onChange(images.filter((_, j) => j !== i))} data-testid={`admin-image-remove-${i}`}
              className="absolute top-1 right-1 bg-white/90 p-1 hover:bg-white"><X className="h-3 w-3" /></button>
          </div>
        ))}
        <label className="aspect-square border border-dashed border-[#C5BCAB] grid place-items-center cursor-pointer hover:border-[#9F7E44] text-xs text-[#57534E] text-center p-2">
          <span><Upload className="h-4 w-4 mx-auto mb-1" />{busy ? "Uploading…" : "Upload"}</span>
          <input type="file" multiple accept=".jpg,.jpeg,.png,.webp" className="sr-only" onChange={upload} disabled={busy} data-testid="admin-photo-input" />
        </label>
      </div>
      <div className="flex gap-2">
        <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="…or paste an image URL" className="field-input" data-testid="admin-image-url-input" />
        <button type="button" onClick={addUrl} className="px-4 border border-[#121417] text-sm" data-testid="admin-image-url-add">Add</button>
      </div>
    </div>
  );
};
